import { SET_SHOW_MODAL } from './../const';

export default (showModal) => {
    return {
      type: SET_SHOW_MODAL,
      showModal: showModal
    }
};